import * as Yup from 'yup';

export const lastName = Yup.string()
  .trim()
  .max(20, 'Last name should be less than 20 symbols')
  .required('Last name is required');
